import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import api from "../services/axios";

const listFromQuery = (payload) => {
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.data?.items)) return payload.data.items;
  return [];
};

const fetchLikedList = async (path) => {
  try {
    const { data } = await api.get(path);
    return data;
  } catch (error) {
    return { data: [] };
  }
};

export const useLikedList = (type, enabled = true) => {
  const city = useSelector((state) => state.citySelector.selectedCity);
  const userBaseCity = useSelector((state) => state.citySelector.userBaseCity);
  const path = `api/user/activities/likes/${type}?city=${city || ""}&userBaseCity=${userBaseCity || ""}`;

  const query = useQuery({
    queryKey: [path],
    queryFn: () => fetchLikedList(path),
    enabled,
    retry: false,
  });

  return {
    items: listFromQuery(query.data),
    isLoading: query.isLoading,
  };
};

export default useLikedList;
